import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Content from './Content';
import IdBar from '../IdBar';
import ReblastTools from './ReblastTools';
import ReblastImpressions from './ReblastImpressions';
import ReblastActions from './ReblastActions';
import CommentsContainer from './CommentsContainer';

function ReblastContainer(props) {
	const data = props.data;
	data.commentsRequestedByUser = false;
	data.commentsPendingId = 0;
	data.commentsAttachmentsId = null;
	data.commentsAttachmentsImage = null;
	data.commentsAttachmentTypeId = null;
	data.isUploadingAttachment = false;
	data.hasMoreCommentsToShow = false;

	const [state, setState] = useState(data);
	const { isFeed } = props;

	const reblastActionRef = useRef();
	const [closeReblastActions, setCloseReblastActions] = useState(0);
	const clickedReblastContainer = event => {
		if (reblastActionRef.current && !reblastActionRef.current.contains(event.target)) {
			setCloseReblastActions(prev => prev + 1);
		}
	};

	return (
		<article
			className={`single-reblast-container ${state.IsFeatured ? 're-pinnedpost' : ''}`}
			data-testid="SingleReblastContainer"
			data-reblastid={data.ReblastId}
			onClick={clickedReblastContainer}
		>
			{data.ContentTrackingUrl ? (
				<img
					src=""
					data-src={data.ContentTrackingUrl}
					width="1"
					height="1"
					className="js-view-pixel visually-hidden"
					data-testid="trackingpixel"
				/>
			): null}
			<div className="re-reblast-idbar re-reblast-idbar-containerwithactions">
				<IdBar
					date={state.ReblastCreatedOn}
					user={state.User}
					GroupName={state.GroupName}
					GroupLinkPublicPage={state.GroupLinkPublicPage}
					HideFirmFeed={state.HideFirmFeed}
					lazy={props.lazy}
					IsScrubbed={state.IsScrubbed}
				/>

				<div ref={reblastActionRef}>
					<ReblastActions
						isFeed={isFeed}
						isGroupAdmin={props.isGroupAdmin}
						deleteReblastFromState={props.deleteReblastFromState}
						closeDropdown={closeReblastActions}
						canPinPost={props.canPinPost}
						state={state}
						setState={setState}
					/>
				</div>
			</div>

			<Content data={state} lazy={props.lazy} />
			<ReblastTools data={state} update={setState} />
			<ReblastImpressions data={state} />
			{!state.IsScrubbed && <CommentsContainer data={state} setState={setState} lazy={props.lazy} />}
		</article>
	);
}

ReblastContainer.propTypes = {
	canPinPost: PropTypes.bool,
	data: PropTypes.object.isRequired,
	deleteReblastFromState: PropTypes.func,
	isFeed: PropTypes.bool,
	isGroupAdmin: PropTypes.bool,
	lazy: PropTypes.bool
};

export default ReblastContainer;
